import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppComponent } from '../app.component';
import { DataService } from '../_services/data.service';

@Component({
  selector: 'app-vista-error-qr',
  templateUrl: './vista-error-qr.component.html',
  styleUrls: ['./vista-error-qr.component.scss']
})
export class VistaErrorQrComponent implements OnInit {

  constructor(private dataService:DataService,
              private appComponent:AppComponent) { }
  error!:string;
  
  ngOnInit(): void {
    this.error=this.dataService.errorProcesoNoExistente;
    this.appComponent.spinnerGeneral=false;
  }

}
